module.exports = __webpack_public_path__ + "media/src/public/fonts/Intro-Regular-8b568858720ce5ee2a9559c7f78602e2.woff";